// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLink_wrapper__L5D0I","active":"PageLink_active__kWctj"};